import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    questions: {count: 0, rows: []},
    loading: false,
    checkDelete: {},
};

const requestQuestionsStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchQuestionsSuccess = ( state, action ) => {
    return updateObject( state, {
        questions: action.questions,
        loading: false
    } );
};

const requestQuestionsFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};

const deleteQuestionsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const checkDeleteQuestionsSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const hardDeleteQuestionsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const updateQuestionsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const postQuestionsSuccess = (state, action) => {
    return updateObject( state, { loading: false } );
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.REQUEST_QUESTIONS_START: return requestQuestionsStart( state, action );
        case actionTypes.FETCH_QUESTIONS_SUCCESS: return fetchQuestionsSuccess( state, action );
        case actionTypes.REQUEST_QUESTIONS_FAIL: return requestQuestionsFail( state, action );
        case actionTypes.DELETE_QUESTIONS_SUCCESS: return deleteQuestionsSuccess( state, action );
        case actionTypes.CHECK_DELETE_QUESTIONS_SUCCESS: return checkDeleteQuestionsSuccess(state, action);
        case actionTypes.UPDATE_QUESTIONS_SUCCESS: return updateQuestionsSuccess( state, action );
        case actionTypes.POST_QUESTIONS_SUCCESS: return postQuestionsSuccess( state, action );
        case actionTypes.HARD_DELETE_QUESTIONS_SUCCESS: return hardDeleteQuestionsSuccess( state, action );

        default: return state;
    }
};

export default reducer;